<div class="dialog-container">
  <h2 mat-dialog-title class="title-bar">{{dialogTitle}} Rule</h2>
  <div mat-dialog-content class="dialog-content">
    <mat-form-field class="example-full-width">
      <textarea mat-autosize="false" [(ngModel)]="ruleData.rule" rows="3" matAutosizeMaxRows="3" matInput></textarea>
    </mat-form-field>
  </div>
  <div mat-dialog-actions mat-footer-row="" class="footer-buttons">
    <button mat-button cdkFocusInitial (click)="onDialogClose(false)">Cancel</button>
    <button mat-button (click)="onDialogClose(true)">Save</button>
  </div>
</div>
